<template>
    <div>
      <div class="flex-col w-1/3 mt-3 pr-4">
        <label class="text-gray-600 text-sm font-semibold mb-3 block">Coupon Name</label>
        <input
        
          v-model="form.name"
          id="coupon-Name"
          placeholder="e.g.: Bagi-Bagi Buku Gramedia"
          type="text"
          :disabled="mode === 'edit' && this.status"
          required
          class="bg-gray-50 py-2.5 px-2 border rounded-lg w-full"
          :class="{
          'border-red-500 placeholder-red-500 bg-red-200 text-red-700 text-base': isCouponNameError,
          'bg-gray-100': mode === 'edit' && this.status
          }"
          @input="validateNameInput"
        />
        <p v-if="isCouponNameError" class="text-red-500 text-sm mt-1">Must be filled.</p>
  
        <label class="text-gray-600 text-sm font-semibold my-3 block">Description</label>
        <textarea
          v-model="form.description"
          id="coupon-description"

          placeholder="Enter a short description..."
          rows="4"
          required
          class="bg-gray-50 py-2.5 px-2 border rounded-lg w-full"
          :class="{ 'border-red-500': isCouponDescriptionError, 'placeholder-red-500 border-red-500 bg-red-200 text-red-700 text-base': isCouponDescriptionError }"
          @input="validateDescriptionInput"
        ></textarea>
        <p v-if="isCouponDescriptionError" class="text-red-500 text-sm mt-1">Must be filled.</p>

        <label class="text-gray-600 text-sm font-semibold my-3 block">Client/Buyer Name</label>
        <input
          v-model="form.bayerName"
          id="coupon-Bayer"
          :disabled="mode === 'edit' && this.status"
          placeholder="e.g.: Gramedia Digital"
          type="text"
          required
          class="bg-gray-50 py-2.5 px-2 border rounded-lg w-full"
          :class="{  'bg-gray-100': mode === 'edit' && this.status, 'placeholder-red-500 border-red-500 bg-red-200 text-red-700 text-base': isCouponBayerNameError }"
          @input="validateBayerNameInput"
        />
        <p v-if="isCouponBayerNameError" class="text-red-500 text-sm mt-1">Must be filled.</p>
        <div class="relative">

        <label class="text-gray-600 text-sm font-semibold my-3 block">Coupon Price</label>
        <input
          v-model="form.couponPrice"
          id="coupon-Bayer"
          placeholder=""
          type="number"
          min="0"
          :disabled="mode === 'edit' &&this.status"
          required
          class="bg-gray-50 py-2.5 pl-8 border rounded-lg w-full"
          :class="{   'bg-gray-100': mode === 'edit' && this.status, 'placeholder-red-500 border-red-500 bg-red-200 text-red-700 text-base': isCouponPriceError }"
          @input="validateCouponPriceInput"
        />
        <p v-if="isCouponPriceError" class="text-red-500 text-sm mt-1">Must be filled.</p>
        <span  :class="{ 'border-red-500': isCouponPriceError, 'placeholder-red-500 bg-red-200 text-red-700 text-base': isCouponPriceError }"
         class="absolute left-2 top-12 mr-2 text-base text-gray-500">Rp</span>
        </div>
        <div class="flex w-full justify-between">
          <DatetimeCustom :timeDate="false" class="mt-3 w-full mr-1.5" :label="'Valid from'" v-model="form.valid_from"></DatetimeCustom>
         <DatetimeCustom :timeDate="false" class="mt-3 w-full ml-1.5" :label="'Valid To'" v-model="form.valid_to"></DatetimeCustom>
        </div>
        <label class="text-gray-600 font-semibold my-3">Platform</label>
        <CustomSelected 
        v-model="selectedPlatforms" 
        :isError="isError" 
        :options="platformFilters"
        label="name"
        track-by="id"
        :class="{'pointer-events-none': editId && this.status}"
        :multiple="true"
        @input="handlePlatformSelection"
        :default-text="'Select Platform'" 
      />

          <p v-if="isError" class="text-red-500 text-sm mt-1">Must be selected.</p>
          <label class="text-gray-600 font-semibold my-3">Product/Offer to Be Redeemed</label>
           <CustomSelected
              class="cursor-pointer"
              v-model="offersPremium"
              :isError="isOfferError"
              :options="premiumOffersOptions"
              label="name"
              track-by="id"
              :multiple="false"
              @input="onFieldChangeOffers"
              @search-change="onSearchPremiumOffers"
              :default-text="'Select Premium Offers'" />
            <div v-if="isOfferError" class="text-red-500 text-xs mt-1">
             Must be selected.
            </div>
        
      <label class="text-gray-600 text-sm font-semibold mb-3 mt-3 block">Status</label>
            <div>
              <button clas type="button" @click="toggleActive" :class="{
                  'bg-blue-700': form.is_active,
                  'bg-gray-300': !form.is_active
                }" class="w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none">
                              <span :class="{
                  'translate-x-6': form.is_active,
                  'translate-x-0': !form.is_active
                }" class="w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200"></span>
              </button>
            </div>
      </div>       
    </div>
  </template>
  
  <script>
  import DatetimeCustom from '../../components/form/Datetime.vue'
  import CustomSelected from '../../components/form/CustomSelected.vue';
  import { mapActions } from "vuex";
  export default {
    name: "CouponDetails",
    components: { 
        DatetimeCustom,
     //   SelectType,
        CustomSelected
    },
    props: {
      form: {
        type: Object,
        required: true,
      },
      mode: {
      type: String,
      default: 'create'
    },
    editId:{
      type:String,
      required:false
    },
    status:{
      type:Boolean,
      required:false
    },
      isCouponNameError: Boolean,
      isCouponDescriptionError: Boolean,
      isCouponBayerNameError:Boolean,
      isCouponPriceError:Boolean,
      isError:Boolean,
      isOfferError:Boolean
    },
    data() {
      return{
        isbulkOffersSearch: false,
        debounce: null,
        bulkOffersSearchOptions: [],
        premiumOffersOptions:[],
        platformFilters: [
      { name: 'iOS', id: 1 },


      { name: 'Android', id: 2 },
      { name: 'Web', id: 4 },
    ],
      }
    },
    computed: {
      selectedPlatforms: {
    get() {
      return this.platformFilters.filter(option =>
        this.form.platforms.some(selected => selected.name.toLowerCase() === option.name.toLowerCase())
      );
    },
    set(selected) {
      this.form.platforms = selected.map(option => ({
        id: option.id,
        name: option.name
      }));
    }
  },
    offersPremium: {
      get() {
        // If form.offersPackage has data, return the first item (single select)
        if (this.form.offersPackage && this.form.offersPackage.length > 0) {
          return this.form.offersPackage[0];
        }
        return null;
    },
     set(selected) {
      console.log('SET',selected)
      this.form.offersPackage = Array.isArray(selected)
      ? selected
      : [selected]
    }
  }
  },
    watch: {
    'form.offersPackage': {
      handler(newVal) {
        // When form.offersPackage is set (during edit), populate premiumOffersOptions
        if (newVal && newVal.length > 0 && this.premiumOffersOptions.length === 0) {
          this.premiumOffersOptions = [...newVal];
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // Load initial offers data when component is mounted
    this.loadInitialOffers();
  },
    methods: {
       ...mapActions('offerspremium', ['searchOffers']),
      ...mapActions("discounts", [
      "searchBulkyOffers",
    ]),

    async loadInitialOffers() {
      try {
        const response = await this.searchOffers({ name: '' });
        if (response?.data?.data?.rows) {
          const allOffers = response.data.data.rows;
          const allowedIds = [150949 ,99551, 44217, 43103];
          
          // Filter berdasarkan is_active dan allowedIds
          const filteredOffers = allOffers.filter(offer => 
            offer.is_active === true && allowedIds.includes(offer.id)
          );
          
          // Filter duplicate berdasarkan name (case-insensitive)
          const uniqueOffers = [];
          const seenNames = new Set();
          
          filteredOffers.forEach(offer => {
            const nameLower = (offer.name || '').toLowerCase();
            if (!seenNames.has(nameLower)) {
              seenNames.add(nameLower);
              uniqueOffers.push(offer);
            }
          });
          
          this.premiumOffersOptions = uniqueOffers;
        }
      } catch (error) {
        console.error('Error loading initial offers:', error);
      }
    },

    handlePlatformSelection(selected) {
      this.form.platforms = selected.map(option => ({
        id: option.id,
        name: option.name
      }));
      // Clear error when platform is selected
      const isError = this.form.platforms.length === 0;
      this.$emit("updateError", { field: "platforms", status: isError });
    },
    onFieldChangeOffers(selected) {
      // Clear error when offer is selected
      const isError = !selected || (Array.isArray(this.form.offersPackage) && this.form.offersPackage.length === 0);
      this.$emit("updateError", { field: "offers", status: isError });
    },
    validateNameInput() {
      const isError = !this.form.name.trim(); 
      this.$emit("updateError", { field: "name", status: isError }); 
    },
    validateDescriptionInput() {
      const isError = !this.form.description.trim(); 
      this.$emit("updateError", { field: "description", status: isError }); 
    },
    validateBayerNameInput() {
      const isError = !this.form.bayerName.trim(); 
      this.$emit("updateError", { field: "bayer_name", status: isError }); 
    },
    validateCouponPriceInput() {
      const isError = !this.form.couponPrice || !this.form.couponPrice.toString().trim(); 
      this.$emit("updateError", { field: "coupon_price", status: isError }); 
    },
    toggleActive() {
      this.form.is_active = !this.form.is_active;
    },
      async onSearchPremiumOffers(query) {
      // If query is empty and we already have data, don't reload
      if (!query && this.premiumOffersOptions.length > 0) {
        return;
      }
      
      try {
        const response = await this.searchOffers({ name: query || '' });
        if (response?.data?.data?.rows) {
          const allOffers = response.data.data.rows;
          const allowedIds = [99551, 44217, 43103];
          
          // Filter berdasarkan is_active dan allowedIds
          const filteredOffers = allOffers.filter(offer => 
            offer.is_active === true && allowedIds.includes(offer.id)
          );
          
          // Filter duplicate berdasarkan name (case-insensitive)
          const uniqueOffers = [];
          const seenNames = new Set();
          
          filteredOffers.forEach(offer => {
            const nameLower = (offer.name || '').toLowerCase();
            if (!seenNames.has(nameLower)) {
              seenNames.add(nameLower);
              uniqueOffers.push(offer);
            }
          });
          
          this.premiumOffersOptions = uniqueOffers;
        }
      } catch (error) {
        console.error('Error searching premium offers:', error);
      }
    },
      handleSearch(query) {
      if (!query) return;
      this.isbulkOffersSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          q: query,
          limit: 10
        };
        this.searchBulkyOffers(payload).then((response) => {
          this.bulkOffersSearchOptions = response.data.data.rows;
          this.isbulkOffersSearch = false;
        }).catch(() => {
          this.isbulkOffersSearch = false;
        });
      }, 600);
    },

    },
  };
  </script>
  <style>
.button-active-inactive {
  position: relative;
  display: inline-flex;
  align-items: center;
}
</style>